import React from 'react';
import { Segment, Button, Header, Icon } from 'semantic-ui-react';

const NotFound = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                Oops - we've looked everywhere but couldn't find this.
            </Header>
            <Segment.Inline>
            <Button primary>
                    This is an Unused button
                </Button>
            </Segment.Inline>
        </Segment>
    );
};

export default NotFound;